import React, { useEffect } from "react";
import ScrollMagic from "scrollmagic";
import FoodrnaContactUs from "../Foodarna/FoodrnaContactUs/FoodrnaContactUs";
import SkilliozHeroSection from "./TestitudeHeroSection";
import Tesitudefeature from "./Tesitudefeature";
import TestitudeTabs from "./TestitudeTabs";
import { Helmet } from "react-helmet-async";

const Skillioz = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const controller = new ScrollMagic.Controller();

    const triggerElement = document.getElementById("triggerPinned");

    if (window.innerWidth > 768 && triggerElement) {
      new ScrollMagic.Scene({
        triggerElement: triggerElement,
        triggerHook: 0,
      })
        .setPin(triggerElement)
        .addTo(controller);
    }

    return () => controller.destroy();
  }, []);
  return (
    <div>
      <Helmet>
        <title>About Owision | Empowering IT & Innovation Globally</title>
        <meta
          name="description"
          content="Discover Owision's Testitude, a powerful software testing solution designed to ensure quality, efficiency, and reliability across web, mobile, and cloud applications."
        />
      </Helmet>
      <div style={{ overflowX: "hidden" }}>
        <div style={{ overflowX: "hidden" }}>
          <section id="triggerPinned" className="sectionBackgroundImage !min-h-[60vh] md:h-[100vh]">
            <SkilliozHeroSection />
          </section>
          <section
            className="project-detail"
            style={{
              zIndex: "1",
              color: "black",
            }}
          >
            <Tesitudefeature />
          </section>
          <section
            className="foodrna-footer-section"
            style={{
              zIndex: "1",
              color: "black",
            }}
          >
            <TestitudeTabs />
            <FoodrnaContactUs />
          </section>
        </div>
      </div>
    </div>
  );
};

export default Skillioz;
